import React from 'react';
import { getIn, useFormikContext } from 'formik';


export const FormikFieldValueChangeHandler: React.VFC<{
  fieldName: string;
  onChange: (value: unknown) => void;
}> = ({ fieldName, onChange }) => {
  const formikContext = useFormikContext<Record<string, unknown>>();
  const fieldValue = getIn(formikContext.values, fieldName);
  const onChangeRef = React.useRef(onChange);

  onChangeRef.current = onChange;

  React.useEffect(() => {
    onChangeRef.current?.(fieldValue);
  }, [ fieldValue ]);

  return null;
};
